import { apiBase, authHeaders } from "./auth";

function parseError(res, data) {
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return `Erro ${res.status}`;
}

async function parseJson(res, label = "API") {
  const ct = (res.headers.get("content-type") || "").toLowerCase();
  const url = typeof res.url === "string" ? res.url : "";
  let raw = "";
  let data = null;
  try {
    raw = await res.text();
    data = raw ? JSON.parse(raw) : null;
  } catch {
    data = null;
  }
  if (!res.ok) {
    throw new Error(
      parseError(res, data && typeof data === "object" ? data : {})
    );
  }
  const looksHtml =
    ct.includes("html") ||
    /^\s*<(!DOCTYPE|html|head|body)\b/i.test(raw || "");
  if (data == null || typeof data !== "object" || Array.isArray(data)) {
    throw new Error(
      looksHtml
        ? `API devolveu HTML (${res.status}${url ? ` em ${url}` : ""}). Em DEV: VITE_API_URL vazio (proxy Vite), reinicie npm start, hard refresh; se persistir, limpe service workers deste origin (DevTools → Application).`
        : `Resposta inválida da ${label} (${res.status}, ${ct || "sem content-type"}${url ? `, ${url}` : ""}).`
    );
  }
  return data;
}

/** Árvore de secções/itens para o painel lateral. */
export async function fetchNavMenu() {
  const res = await fetch(`${apiBase()}/sca/nav/menu`, {
    credentials: "include",
    cache: "no-store",
    headers: authHeaders(),
  });
  const data = await parseJson(res, "menus");
  if (!Array.isArray(data.sections)) {
    throw new Error("Resposta de menus sem secções.");
  }
  return data;
}

/** Favoritos do utilizador (Home). */
export async function fetchNavFavorites() {
  const res = await fetch(`${apiBase()}/sca/nav/favorites`, {
    credentials: "include",
    cache: "no-store",
    headers: authHeaders(),
  });
  const data = await parseJson(res, "favoritos");
  if (!Array.isArray(data.items)) {
    throw new Error("Resposta de favoritos inválida.");
  }
  return data;
}

/** Substitui a lista ordenada de favoritos. */
export async function putNavFavorites(cdMenus) {
  const res = await fetch(`${apiBase()}/sca/nav/favorites`, {
    method: "PUT",
    credentials: "include",
    cache: "no-store",
    headers: authHeaders(),
    body: JSON.stringify({ cd_menus: cdMenus }),
  });
  return parseJson(res, "favoritos");
}

export async function addNavFavorite(cdMenu) {
  const res = await fetch(
    `${apiBase()}/sca/nav/favorites/${encodeURIComponent(cdMenu)}`,
    {
      method: "POST",
      credentials: "include",
      cache: "no-store",
      headers: authHeaders(),
    }
  );
  return parseJson(res, "favoritos");
}

export async function removeNavFavorite(cdMenu) {
  const res = await fetch(
    `${apiBase()}/sca/nav/favorites/${encodeURIComponent(cdMenu)}`,
    {
      method: "DELETE",
      credentials: "include",
      cache: "no-store",
      headers: authHeaders(),
    }
  );
  return parseJson(res, "favoritos");
}

export function isNavItemLocked(item) {
  return Boolean(
    item?.locked_license ||
      item?.locked_audience ||
      item?.locked_auth ||
      item?.locked_company
  );
}

export function navItemLockTitle(item) {
  if (item?.locked_auth) return "Sem autorização de acesso para esta tela";
  if (item?.locked_license) return "Módulo não licenciado para este contrato";
  if (item?.locked_audience) return "Sem permissão para esta secção";
  if (item?.locked_company) return "Selecione uma empresa ativa no topo da tela";
  return "";
}
